import { StopAutoplayCommand } from "slotworks/commands/autoplay/stop-autoplay";
import { BetBarType } from "slotworks/components/betbar/bet-bar-component";
import Components from "slotworks/components/components";
import Layers from "slotworks/graphics/layers/layers";
import Translations from "slotworks/i18n/translations";
import BetMenuFreespinsMediator from "slotworks/mediators/bet-menu-freespins-mediator";
import AutoplayModel from "slotworks/model/autoplay-model";
import Gamestate from "slotworks/model/game-state";
import GameState from "slotworks/model/game-state";
import SmartButton from "slotworks/smart-button/smart-button";
import { SmartButtonFlag } from "slotworks/smart-button/smart-button";
import State from "slotworks/state-machine/states/state";
import HidePromoFSonFreespins from "slotworks/commands/promo-free-spins/hide-pfs-on-freespins";


export default class EnterFreespins extends State {
    public onEnter() {
        super.onEnter();

        if (AutoplayModel.stopOnFeatureWin) {
            StopAutoplayCommand();
        }

        // if campaing is active we change the way smart button works to regular freespins
        HidePromoFSonFreespins();

        SmartButton.setFlag(SmartButtonFlag.PROMPT, true);
        SmartButton.setFlag(SmartButtonFlag.FREE_SPINS, true);

        Components.betBar.setType(BetBarType.FREESPINS);
        new BetMenuFreespinsMediator().start().execute();
        // Update remaining to use undeducted value during the prompt
        Components.betBar.setRemainingFreespins(Math.max(0, GameState.getCurrentGame().getTotalFreespinsWon()));

        this.showPrompt();
    }

    public complete() {
        GameState.getCurrentGame().inFreespinsGame = true;
        SmartButton.setFlag(SmartButtonFlag.PROMPT, false);

        super.complete();
    }

    protected showPrompt(scenes: string[] = ["freespinswin", "freespins"], contents?: Map<string, string>) {
        if (Layers.Prompts.hasAnyScene(scenes)) {
            const record = Gamestate.getCurrentGame().getCurrentRecord();

            if (!contents) {
                contents = new Map<string, string>();
            }

            contents.set("winMessage", Translations.get("fs.tri", {VALUE: record.freespinsWon}));
            contents.set("value", record.freespinsWon.toString());

            Components.prompt.show(scenes, contents).then(() => this.complete());

            Layers.Prompts.onSceneExit.addOnce(() => this.showFreespinsElements());
        } else {
            this.showFreespinsElements();
            this.complete();
        }
    }

    protected showFreespinsElements() {
        if (Layers.Background.hasScene("freespins")) {
            Layers.Background.setScene("freespins").execute();
        }
        if (Layers.MatrixBackground.hasScene("freespins")) {
            Layers.MatrixBackground.setScene("freespins").execute();
        }
        if (Layers.Header.hasScene("freespins")) {
            Layers.Header.setScene("freespins").execute();
        }
        Components.banner.setMode("freespins");
    }
}



// WEBPACK FOOTER //
// ./~/slotworks/state-machine/standard/states/enter-freespins.ts